module.exports = __webpack_public_path__ + "img/image-middle@2x.a3da4241.png";